import React from 'react';
import { IconProps } from 'src/assets/icons/types';

const PDFFileIcon: React.FC<IconProps> = props => {
  const { size = 32 } = props;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="none">
      <g id="pdf-svgrepo-com 1">
        <path
          id="Vector"
          d="M8 0C6.9 0 6 0.9 6 2V30C6 31.1 6.9 32 8 32H28C29.1 32 30 31.1 30 30V8L22 0H8Z"
          fill="#E2E5E7"
        />
        <path id="Vector_2" d="M24 8H30L22 0V6C22 7.1 22.9 8 24 8Z" fill="#B0B7BD" />
        <path id="Vector_3" d="M30 14L24 8H30V14Z" fill="#CAD1D8" />
        <path
          id="Vector_4"
          d="M26 26C26 26.55 25.55 27 25 27H3C2.45 27 2 26.55 2 26V16C2 15.45 2.45 15 3 15H25C25.55 15 26 15.45 26 16V26Z"
          fill="#F15642"
        />
        <g id="Group">
          <path
            id="Vector_5"
            d="M6.35864 18.9426C6.35864 18.6786 6.56664 18.3906 6.90164 18.3906H8.74864C9.78864 18.3906 10.7246 19.0866 10.7246 20.4206C10.7246 21.6846 9.78864 22.3886 8.74864 22.3886H7.41364V23.4446C7.41364 23.7966 7.18964 23.9956 6.90164 23.9956C6.63764 23.9956 6.35864 23.7966 6.35864 23.4446V18.9426ZM7.41364 19.3976V21.3896H8.74864C9.28464 21.3896 9.70864 20.9166 9.70864 20.4206C9.70864 19.8616 9.28464 19.3976 8.74864 19.3976H7.41364Z"
            fill="white"
          />
          <path
            id="Vector_6"
            d="M12.2856 23.9988C12.0216 23.9988 11.7336 23.8548 11.7336 23.5038V18.9618C11.7336 18.6748 12.0216 18.4658 12.2856 18.4658H14.1166C17.7706 18.4658 17.6906 23.9988 14.1886 23.9988H12.2856ZM12.7896 19.4418V23.0238H14.1166C16.2756 23.0238 16.3716 19.4418 14.1166 19.4418H12.7896Z"
            fill="white"
          />
          <path
            id="Vector_7"
            d="M18.9929 19.5005V20.7715H21.0319C21.3199 20.7715 21.6079 21.0595 21.6079 21.3385C21.6079 21.6025 21.3199 21.8185 21.0319 21.8185H18.9929V23.4975C18.9929 23.7775 18.7939 23.9925 18.5139 23.9925C18.1619 23.9925 17.9469 23.7775 17.9469 23.4975V18.9555C17.9469 18.6685 18.1629 18.4595 18.5139 18.4595H21.3209C21.6729 18.4595 21.8809 18.6685 21.8809 18.9555C21.8809 19.2115 21.6729 19.4995 21.3209 19.4995H18.9929V19.5005Z"
            fill="white"
          />
        </g>
        <path
          id="Vector_8"
          d="M25 27H6V28H25C25.55 28 26 27.55 26 27V26C26 26.55 25.55 27 25 27Z"
          fill="#CAD1D8"
        />
      </g>
      <defs>
        <clipPath id="clip0_10569_186265">
          <rect width={size} height={size} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PDFFileIcon;
